import styled from 'styled-components';

const Span = styled.span`
  font-size: 12px;
  color: ${props => props.theme.main.red};
`;

export default Span;
